interface CopilotHiddenFieldProps {
  fieldKey: string
  value: string
}

/**
 * Emit a fully hidden field node with both data-copilot-field and data-copilot-value.
 * Use this when there is no obvious visible DOM container to attach the field to.
 */
export const CopilotHiddenField = ({
  fieldKey,
  value,
}: CopilotHiddenFieldProps) => {
  return (
    <div
      data-copilot-field={fieldKey}
      data-copilot-value={value}
      className="hidden"
    />
  )
}
